<!-- @format -->

<template>
	<el-row>
		<template v-for="item in widgetDatas" :key="item.code">
			<el-col v-if="item.category === 'container' && !item.options.hidden" :span="+item.options.cols">
				<!-- label为透传给form-item组件的属性 -->
				<component
					:is="getWidgetName(item.type)"
					v-model="value[item.options.code]"
					:item="item"
					:form-disabled="disabled"
					type="render"
					@field-change="(...args:any[]) => emit('fieldChange', ...args)"
				>
					<index v-model="value" :widget-datas="item.children" :disabled="disabled" :show-label-icon="showLabelIcon" />
				</component>
			</el-col>

			<el-col v-else-if="!item.options.hidden" :span="+item.options.cols">
				<FormItem
					v-show="item.type !== 'placeholder'"
					v-model="value[item.options.code]"
					:item="item"
					:prop="item.options.code"
					:disabled="disabled"
					:show-label-icon="showLabelIcon"
				/>
			</el-col>
		</template>
	</el-row>
</template>

<script setup lang="ts">
	import { getWidgetName } from './Components';
	import FormItem from './FormItem.vue';

	interface Props {
		modelValue: any;
		widgetDatas: any[];
		disabled?: boolean;
		showLabelIcon?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		disabled: false,
	});

	const emit = defineEmits(['update:modelValue', 'fieldChange']);

	const value = computed({
		get() {
			return props.modelValue || {};
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
